import formConsulta from "@/components/consultas/formConsulta/formConsulta.vue";
import VerConsulta from "./verConsulta.vue";
import consultaList from "@/components/consultas/consultaList/consultaList.vue"


export default {
	name: "Consultas",
	props: ["form"],

	components: {
		formConsulta,
		VerConsulta,
		consultaList
	},
	data() {
		return {
			loadPaginate: false,
			userId: '',
			dadosSolicitante: {
				nome: '',
				telefone: '',
				cidade: '',
				uf: '',
				emails: ''
			},
			abrirNovaConsulta: {
				intOpcao: 0,
				strAcao: null
			},
			showList: false,
			blMostrarformConsulta: false,
			dialogRemover: false,

			registro: {
				_id: 0,
				strNome: ""
			},
			//arRegistros: [],
			consultas: {
				totalConsultas: null,
				totalPagina: '',
				limitePagina: '',
				paginaAtual: 1,
				ultimaPagina: '',
				consultas: [{
					id: '',
					idConsultoriaLegado: '',
					idCliente: '',
					idConsultorResponsavel: '',
					blTeste: localStorage.getItem("demonstrativo") ? 1 : 0,
					strNome: '',
					strEmail: '',
					strTelefone: '',
					dtCadastro: '',
					dtAlteracao: '',
					strUFCliente: '',
					strCidadeCliente: '',
					strAssunto: '',
					strUFConsulta: '',
					blDeletado: '',
					idStatus: '',
					txObservacao: '',
					blDuplicada: '',
					blLida: '',
					txRascunho: '',
					dtInicio: '',
					dtPrazo: '',
					idArea: '',
					idTema: '',
					blApp: '',
					blReplique: '',
					txMotivoSigilo: '',
					blSigilosa: '',
					idConsultaOrigem: '',
					blFerias: '',
					intIndice: '',
					blRascunho: '',
					strPalavraChave: '',
					txMotivoAtribuicao: '',
					txMotivoDelete: '',
					idUsuarioDelete: '',
					txMotivoRestauracao: '',
					txMensagem: '',
					dtInicioAtendimento: '',
					diferencial: '',
					blAprovacao: '',
					blVencidaCadastrada: '',
					dtCadastroConsulta: '',
					dtAnoCadastro: '',
					intNaoAvaliadas: '',
					intQntPerguntas: '',
					strTema: '',
					strAreaApelido: '',
					strNomeArea: '',
					strApelidoArea: ''
				}]

			},
			listAreas: [{
				id: '',
				strDescricao: '',
				strNome: ""
			}]
		};
	},
	created() {
		//Valida
		this.mountConsultas()
		this.showList = typeof this.$refs.ver_con === 'undefined'
		//this.obterRegistros()


	},

	watch: {
		paginaAtual(novo, atual) {
			this.updatePage()
		},
		idAreaLista(novo, atual){
			
			this.filtrarConsultas()
		},
		idTema(novo, atual){
			this.filtrarConsultas()
			//this.filtrarConsultas()
		},
		buscaPalavra(novo, atual){
			this.filtrarConsultas()
		},
		refreshList(novo, atual){
			this.filtrarConsultas()
		}

	},
	mounted() {

	},
	updated() {
		this.showList = typeof this.$refs.ver_con === 'undefined';
	
	},
	computed: {
		paginaAtual() {
			return this.$root.$store.state.paginaAtual
		},
		idAreaLista(){
			return this.$root.$store.state.idAreaLista
		},
		idTema(){
			return this.$root.$store.state.idTema
		},
		buscaPalavra(){
			return this.$root.$store.state.pesquisaPalavra
		},
		refreshList() {
			return this.$root.$store.state.refreshList
		}

	},
	methods: {
		mountConsultas() {
			/**
			 * Essa função faz as requisições necessárias para funções básicas da aplicação
			 * Como: 
			 * 		- Logar para pegar Token, 
			 * 		- Pegar o Id do Usuário a partir do cookie do PHPESSID
			 * 		- Com o Token e Id do Usuário pegaremos as informações do Usuário (email, uf, nome, cidade, telefone)
			 * ________________
			 * 
			 * Obteremos um token a partir de um usuário padrão
			 * Com esse token será possível obter os dados do solivitante 
			 * ________________
			 * 
			 * O ID do usuário é obtido a partir de um cookie chamado PHPSESSID setado pelo próprio site da Econet
			 * Dentro deste cookie vem outras informações concatenadas, foi observado que o Id são os primeiros caracteres até o "eee"
			 * Faremos um replace para obter ele
			 * 
			 * ________________
			 * A rota de Obter os dados do Solicitante pede o Token e o Id do Usuário
			 * 
			 * 
			 */

			this.$root.$api.obterToken().then(response => {
				/**
				 * Recebendo o id pelo PHPSESSID
				 * 
				 * var cookieId = this.$root.$api.getCookie('PHPSESSID')
				 * this.$root.$store.state.idUsuario = cookieId.replace(/([\w\W]*)(?:eee[\w\W]*)/gm, '$1')
				 */

				/**
				 * Recebendo o Id pelo base64
				 */
				var cookieId = this.$root.$api.getCookie('bG9naW4')

				if (cookieId == "") {
					setTimeout(function(){
						window.location.href = "http://www.econeteditora.com.br";
					},1000);					
				}

				cookieId = JSON.parse(atob(decodeURIComponent(cookieId)))
				if(cookieId.demonstrativo) {
					localStorage.setItem("demonstrativo",true);
					localStorage.setItem("email2",cookieId.email);
				}else {
					localStorage.removeItem("demonstrativo");
					localStorage.removeItem("email2");
				}

				if (cookieId.email && cookieId.email.indexOf('@econet') !== -1) {
					localStorage.setItem('blInterno', true);
				} else {
					localStorage.removeItem('blInterno');
				}

				this.$root.$store.state.idUsuario = cookieId.id
				
				//this.$root.$store.state.idUsuario = '17911'

				this.$root.$store.state.token = response
				var token = this.$root.$store.state.token
				var userId = this.$root.$store.state.idUsuario
				var atualPage = this.$root.$store.state.paginaAtual

				this.$root.$api.listarAreas(token).then(response => {

					this.$root.$store.state.areas = response
				})
				this.$root.$api.ObterDadosSolicitante(userId, token).then(response => {
					this.$root.$store.state.dadosSolicitante = response
				})

				/**
				 * Montaremos o form-data com os dados necessários para obter a listagem de consultas
				 * 
				 */
				var form = new FormData();
				form.append("idCliente", userId);
				form.append("token", token);
				form.append("paginaAtual", atualPage);
				form.append("limitePagina", "10");

				if(!localStorage.getItem("demonstrativo")) {
					this.$root.$api.listarConsultas(form).then(response => {
						this.consultas = response
						this.$root.$store.state.loadingConsultas = false
						/**
						 * Aqui setaremos o encerramento do loader
						 */
					})
				}else {
					this.consultas = {
						"totalConsultas": 0,
						"totalPagina": 0,
						"limitePagina": 30,
						"paginaAtual": 1,
						"ultimaPagina": 0,
						"consultas": []
					};
					this.$root.$store.state.loadingConsultas = false;
					
				}
			})
		},

		updatePage() {
			var atualPage = this.$root.$store.state.paginaAtual
			var token = this.$root.$store.state.token
			var userId = this.$root.$store.state.idUsuario
			var idArea = this.$root.$store.state.idAreaLista
			var idTema = this.$root.$store.state.idTema
			var strBusca = this.$root.$store.state.pesquisaPalavra

			this.$root.$store.state.loadingConsultas = true 
			/**
			 * Montaremos o form-data com os dados necessários para obter a listagem de consultas
			 * 
			 */
			var form = new FormData();
			form.append("idCliente", userId);
			form.append("token", token);
			form.append('idArea', idArea);
			form.append('idTema', idTema);
			form.append('strBusca', strBusca);
			form.append("paginaAtual", atualPage);
			form.append("limitePagina", "10");
			this.loadPaginate = true
			this.$root.$api.listarConsultas(form).then(response => {
				this.loadPaginate = false
				this.consultas = response
			
				/**
				 * Aqui setaremos o encerramento do loader
				 */
				 this.$root.$store.state.loadingConsultas = false 
			})
		},

		filtrarConsultas(){
			if(!localStorage.getItem("demonstrativo")) {
				
				this.$root.$store.state.loadingConsultas = true 
				var atualPage = 1
				var token = this.$root.$store.state.token
				var userId = this.$root.$store.state.idUsuario
				var idArea = this.$root.$store.state.idAreaLista
				var idTema = this.$root.$store.state.idTema
				var strBusca = this.$root.$store.state.pesquisaPalavra
				var form = new FormData()
				/**
				 * Montaremos o form-data com os dados necessários para obter a listagem de consultas
				 * 
				 */
			
				form.append("idCliente", userId);
				form.append("idArea", idArea);
				form.append("token", token);
				form.append("strBusca", strBusca);
				form.append("idTema", idTema);
				
				form.append("paginaAtual", atualPage);
				form.append("limitePagina", "10");
	
				this.loadPaginate = true
				this.$root.$api.listarConsultas(form).then(response => {
					this.loadPaginate = false
					this.consultas = response
					this.$root.$store.state.loadingConsultas = false 
					/**
					 * Aqui setaremos o encerramento do loader
					 */
				})
			}
			
		},

		selecionaRegistro(registro) {
			this.$emit("setLoading", true);
			this.$root.$api
				.post("getRegistro", {
					_id: registro._id
				})
				.then(resposta => {
					registro = resposta.retorno[0];
					let objRegistro = JSON.parse(registro.jsonRegistro);
					objRegistro._id = registro._id;
					objRegistro.created_at = registro.created_at;
					objRegistro.updated_at = registro.updated_at;
					this.$emit("selecionarRegistro", objRegistro);
				});
		},

		abrirDialogExcluir(registro) {
			this.registro = {
				_id: registro._id,
				strNome: registro.strNome
			};
			this.dialogRemover = true;
		},
		fecharDialogExcluir() {
			this.dialogRemover = false;
		},

		mostrarformConsulta() {
			this.mostrarformConsulta = true;
		},
		submitformConsulta() {

		}
	}
};